import { CreatePolicyType } from "../../pages/components/pay_now/type";
import { Validations } from "../../types/shared/Validation";

const AMOUNT_REGEX = /^[0-9]+(\.[0-9]{1,2})?$/;

const validateAmount = (amount: number): string | null => {
  if (!AMOUNT_REGEX.test(amount.toString())) {
    return "Must be digits and at most 2 decimal digits only";
  }

  return null;
};

export const policyDetailsValidations: Validations<CreatePolicyType> = {
  fields: {
    insuredName: {
      required: true,
      length: {
        maxLength: 60,
        message: "Text exceeds max. length",
      },
    },
    policyNumber: {
      required: true,
      length: {
        maxLength: 60,
        message: "Text exceeds max. length",
      },
    },
    email: {
      required: {
        message: "Email is required",
      },
      pattern: {
        regex: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
        message: "Please check email format",
      },
    },
    contactNumber: {
      required: false,
      custom: {
        validate: (contactNumber: unknown) => {
          if (contactNumber === null || contactNumber === undefined || contactNumber === "") {
            return null;
          }
          return /^[0-9]{8}$/.test(contactNumber as string) ? null : "Must be 8 digits";
        },
      },
    },
    amount: {
      required: true,
      custom: {
        validate: (amount: unknown) => {
          return validateAmount(amount as number);
        },
      },
    },
  },
};
